import PropTypes from 'prop-types';
import React from 'react'


export default class extends React.Component {
    static propTypes = {
		field: PropTypes.string.isRequired,
		text: PropTypes.string.isRequired,
		answer: PropTypes.string,
		subQuestion: PropTypes.object,
		changeMainAnswer: PropTypes.func.isRequired,
		changeSubAnswer: PropTypes.func.isRequired
	};

    state = {
        showSubQuestion: false,
        answered: 'answer' in this.props,
        newAnswer: ''
    };

    mainAnswer = (answer, e) => {
		this.props.changeMainAnswer(this.props.field, answer)
		this.setState({
			answered: true
		})
		if( !!this.props.subQuestion ) this.showSubQuestion()
	};

    subAnswer = (answer, e) => {
		this.props.changeSubAnswer(this.props.field, answer)
		this.setState({
			showSubQuestion: false
		})
	};

    showSubQuestion = () => {
		this.setState({
			showSubQuestion: true
		})
	};

    render() {

		let isSubQuestion = !!this.props.subQuestion && this.state.showSubQuestion && (this.props.answer === this.props.subQuestion.condition),
			subAnswerQuestion = isSubQuestion ? (!!this.state.newAnswer ? this.state.newAnswer : this.props.subQuestion.answer) : false;

		return (
			<div className="question-item">
				<div className="question-box">
					<p className="text-white">{this.props.text}</p>
					{ !!this.props.subQuestion && !!this.props.subQuestion.answer && this.props.subQuestion.condition === this.props.answer &&
						<p className="text-dark-gray"><em>{this.props.subQuestion.answer}</em></p>
					}
				</div>
				<div className="answer-box">
					<span className={"clickable true " + (this.state.answered && this.props.answer === 'true' ? "selected" : "")} onClick={this.mainAnswer.bind(this, true)}><i className="icon-check text-white"></i></span>
					<span className={"clickable false " + (this.state.answered && this.props.answer === 'false' ? "selected" : "")} onClick={this.mainAnswer.bind(this, false)}><i className="icon-cross2 text-white"></i></span>
				</div>
				{ isSubQuestion &&
					<div className="sub-question">
						<div className="sub-question-title"><p className="text-center text-white mbot0">{this.props.subQuestion.text}</p></div>
						<ul className="no-list text-left text-white">
							{this.props.subQuestion.answers.map(answer => {
								return <li className="clickable" onClick={this.subAnswer.bind(this, answer)}>
									<span>
										<i className={"icon icon-check " + (answer === subAnswerQuestion ? 'text-light-success' : 'text-transparent')}> </i>
										{answer}
									</span>
								</li>
							})}
						</ul>
					</div>
				}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/js/views/Registration/RegistrationParts/TemplateParts/QuestionItem.jsx